import { useTranslation } from 'react-i18next';
import { useSnapshot } from 'valtio';
import { ParticipantPhoneNumberType } from './ParticipantPhoneNumberGroup.types';
import { commonFields } from 'modules/events/basics/constants/commonFormFields.constants';
import { EventStateType } from 'modules/events/basics/types/events.types';
import eventState from 'modules/events/states/events.states';

const useParticipantPhoneNumberConfig = () => {
  const { t } = useTranslation();
  const snap = useSnapshot(eventState) as EventStateType;

  const participantPhoneNumberConfig: ParticipantPhoneNumberType = {
    collectParticipantPhoneNumber: {
      label: t('events_collect_participant_phone_number_label'),
      name: commonFields.collectParticipantPhoneNumber,
      checked: snap.createEvent.data?.collectParticipantPhoneNumber || false,
    },

    collectPhoneNumberMandatory: {
      label: t('events_collect_phone_number_mandatory_label'),
      name: commonFields.collectPhoneNumberMandatory,
      checked: snap.createEvent.data?.collectPhoneNumberMandatory || false,
    },

    collectPhoneNumberUserConsent: {
      label: t('events_collect_phone_number_userConsent_label'),
      name: commonFields.collectPhoneNumberUserConsent,
      checked: snap.createEvent.data?.collectPhoneNumberUserConsent || false,
    },

    collectTextMessageUserConsent: {
      label: t('events_collect_text_message_userConsent_label'),
      name: commonFields.collectTextMessageUserConsent,
      checked: snap.createEvent.data?.collectTextMessageUserConsent || false,
      disabled: false,
    },
  };

  return {
    participantPhoneNumberConfig,
  };
};

export default useParticipantPhoneNumberConfig;
